export interface TimeEntryArchiveClass {
    AccountEmployeeTimeEntryId: number,
    TimeEntryViewType:string,
    TimeEntryDate:Date,
    TimeEntryStartDate:Date,
    TimeEntryEndDate:Date,
    AccountEmployeeId:number,
    EmployeeName:string,
    AccountProjectId:number,
    ProjectName:string,
    AccountProjectTaskId:number,
    TaskName:string,
    StartTime:Date,
    EndTime:Date,
    Hours:number
    TotalTime:string,
    Percentage:number,
    BillingRate:number,
    Approved:Boolean,
    Rejected:Boolean,
    Submitted:Boolean,
    isSelected:number,
    AccountId:number,
    AccountEmployeeTimeEntryPeriodId:string,
    AccountEmployeeTimeEntryApprovalProjectId:string,
    IsTimeOff:boolean,
    Reason:string
}
export const TimeEntryArchiveInitialsForAdd={
    TimeEntryViewType:"",
    TimeEntryDate:new Date(),
    TimeEntryStartDate:new Date(),
    TimeEntryEndDate:new Date(),
    AccountEmployeeId:0,
    EmployeeName:"",
    AccountProjectId:0,
    ProjectName:"",
    AccountProjectTaskId:0,
    TaskName:"",
    StartTime:new Date(),
    EndTime:new Date(),
    Hours:0,
    TotalTime:0,
    Percentage:0,
    BillingRate:0,
    Approved:false,
    Rejected:false,
    Submitted:false,
    AccountId:0,
    AccountEmployeeTimeEntryPeriodId:"",
    AccountEmployeeTimeEntryApprovalProjectId:"",
    IsTimeOff:false,
    Reason:""
}

export const TimeEntryArchiveInitialsForUpdate={
    AccountEmployeeTimeEntryId:0,
    TimeEntryViewType:"",
    TimeEntryDate:new Date(),
    TimeEntryStartDate:new Date(),
    TimeEntryEndDate:new Date(),
    AccountEmployeeId:0,
    EmployeeName:"",
    AccountProjectId:0,
    ProjectName:"",
    AccountProjectTaskId:0,
    TaskName:"",
    StartTime:new Date(),
    EndTime:new Date(),
    Hours:0,
    TotalTime:0,
    Percentage:0,
    BillingRate:0,
    Approved:false,
    Rejected:false,
    Submitted:false,
    AccountId:0,
    AccountEmployeeTimeEntryPeriodId:"",
    AccountEmployeeTimeEntryApprovalProjectId:"",
    IsTimeOff:false,
    Reason:""
}


